module.exports = __webpack_public_path__ + "img/7-full-lg.075b76c6.jpg";